import { cn } from "@/lib/utils"

export interface StatCardProps {
  value: string
  description: string
  highlight?: string
  highlightColor?: string
  source?: string
  sourceUrl?: string
  className?: string
}

function highlightText(text: string, highlight: string, color?: string) {
  const index = text.indexOf(highlight)
  if (index === -1) return <>{text}</>
  return (
    <>
      {text.slice(0, index)}
      <strong className="font-bold" style={color ? { color } : undefined}>
        {highlight}
      </strong>
      {text.slice(index + highlight.length)}
    </>
  )
}

export function StatCard({
  value,
  description,
  highlight,
  highlightColor,
  source,
  sourceUrl,
  className,
}: StatCardProps) {
  return (
    <div
      className={cn(
        "rounded-[24px] border border-white text-center",
        className
      )}
      style={{ background: "rgba(255, 255, 255, 0.80)", padding: 40 }}
    >
      <p className="type-display-lg font-light text-neutral-900">{value}</p>
      <p className="mt-4 text-base font-medium text-neutral-600">
        {highlight
          ? highlightText(description, highlight, highlightColor)
          : description}
      </p>
      {source && (
        <p className="mt-4 text-sm text-neutral-400">
          {sourceUrl ? (
            <a
              href={sourceUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="underline decoration-neutral-200 hover:text-neutral-600"
            >
              {source}
            </a>
          ) : (
            source
          )}
        </p>
      )}
    </div>
  )
}
